module.exports = __webpack_public_path__ + "static/img/lmaesFalcon.8084603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lmaesFalcon.png
// module id = 9vFo
// module chunks = 0